import gql from 'graphql-tag'

export const closeAccountQuery = gql`
  query CloseAccountQuery {
    allCloseAccountReasons {
      key
      label
    }
    user {
      uuid
    }
  }
`
